/**
 * Gestão dos acessos compartilhados da Dash Gerencial (admin sem instituição).
 */

import { api } from '@/lib/api/client'
import type { ManagerialDashboardShare, ManagerialDashboardShareCandidate } from '@/types/api'

export async function fetchManagerialDashboardShares(
  signal?: AbortSignal
): Promise<ManagerialDashboardShare[]> {
  const response = await api.get<{ shares: ManagerialDashboardShare[] }>(
    '/api/admin/managerial-dashboard/shares',
    { requireAuth: true, signal }
  )
  return Array.isArray(response.shares) ? response.shares : []
}

export async function fetchManagerialDashboardShareCandidates(
  search: string,
  signal?: AbortSignal
): Promise<ManagerialDashboardShareCandidate[]> {
  const query = new URLSearchParams()
  const term = search.trim()
  if (term !== '') {
    query.set('search', term)
  }
  const suffix = query.toString()
  const endpoint = suffix
    ? `/api/admin/managerial-dashboard/share-candidates?${suffix}`
    : '/api/admin/managerial-dashboard/share-candidates'
  const response = await api.get<{ institutions: ManagerialDashboardShareCandidate[] }>(endpoint, {
    requireAuth: true,
    signal,
  })
  return Array.isArray(response.institutions) ? response.institutions : []
}

export async function grantManagerialDashboardShare(input: {
  institutionId: number
  expiresOn: string
}): Promise<ManagerialDashboardShare> {
  const response = await api.post<{ share: ManagerialDashboardShare }>(
    '/api/admin/managerial-dashboard/shares',
    {
      institution_id: input.institutionId,
      expires_on: input.expiresOn,
    },
    { requireAuth: true }
  )
  return response.share
}

export async function updateManagerialDashboardShareExpiry(input: {
  shareId: number
  expiresOn: string
}): Promise<ManagerialDashboardShare> {
  const response = await api.patch<{ share: ManagerialDashboardShare }>(
    `/api/admin/managerial-dashboard/shares/${input.shareId}`,
    { expires_on: input.expiresOn },
    { requireAuth: true }
  )
  return response.share
}

export async function revokeManagerialDashboardShare(shareId: number): Promise<void> {
  await api.delete(`/api/admin/managerial-dashboard/shares/${shareId}`, {
    requireAuth: true,
  })
}
